<template>
  <div class="tip">
    <div class="tip-title">提示：</div>
    <div>支持提交后再次编辑，访问路径：【企业运营中心】-【设置】-【基础信息设置】-【产品碳足迹信息】</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.tip {
  width: 100%;
  height: 44px;
  background: #e8efff;
  line-height: 44px;
  padding: 0 10px;
  display: flex;
  font-size: 14px;
  color: #333;
}
.tip-title {
  color: #f0250f;
  font-size: 14px;
  font-weight: 700;
  margin-right: 4px;
}
</style>
